let currentOverlay = null;

// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement("img");
  overlayImage.setAttribute("src", `${image.src}`);
  const overlay = document.createElement("div");
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = "50%";
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = "100%";
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute("class", "image-magnify-full-size");
  container.setAttribute("aria-hidden", "true");
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = "var(--gradient-background)";
}

function toggleLoadingSpinner(image) {
  const loadingSpinner =
    image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) {
    loadingSpinner.classList.toggle("hidden");
  }
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  if (currentOverlay) {
    currentOverlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    currentOverlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
}

function magnify(image, zoomRatio) {
  // If an overlay already exists, remove it (toggle off)
  if (currentOverlay) {
    currentOverlay.remove();
    currentOverlay = null;
    image.style.opacity = "100%";
    return;
  }

  currentOverlay = createOverlay(image);
  currentOverlay.onclick = () => {
    currentOverlay.remove();
    currentOverlay = null;
    image.style.opacity = "100%";
  };
  currentOverlay.onmousemove = (event) =>
    moveWithHover(image, event, zoomRatio);
  currentOverlay.onmouseleave = () => {
    if (currentOverlay) {
      currentOverlay.remove();
      currentOverlay = null;
      image.style.opacity = "100%";
    }
  };
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll(".image-magnify-hover");
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
